import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { SharedService } from '@ml/shared/services/shared.service';
import strings from '../../../assets/i18n/strings';
import { Router } from '@angular/router';

@Injectable()
export class ErrorsHandler implements ErrorHandler {
  // Error handling is important and needs to be loaded first.
  // Because of this we should manually inject the services with Injector.
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const sharedService = this.injector.get<SharedService>(SharedService);

    if (error.status === 404) {
      const router = this.injector.get<Router>(Router);
      const zone = this.injector.get<NgZone>(NgZone);

      return zone.run(() => {
        router.navigate(['not-found']);
      });
    }

    if (error.status === 401) {
      return;
    }

    if (!navigator.onLine) {
      sharedService.showMessage(strings.browserOffline, null, null, 'Close', [
        'error-color'
      ]);
    } else {
      sharedService.showMessage(strings.errorOccurred, null, null, 'Close', [
        'error-color'
      ]);
    }
    throw error;
  }
}
